import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';

interface RowCountDropdownProps {
  rowCount: number;
  customRowCount: string;
  effectiveRowCount: number;
  showDropdown: boolean;
  showInputWarning?: boolean;
  options: number[];
  disabled?: boolean;
  onToggleDropdown: () => void;
  onCloseDropdown: () => void;
  onSelect: (count: number) => void;
  onCustomChange: (value: string) => void;
}

export const RowCountDropdown: React.FC<RowCountDropdownProps> = ({
  rowCount,
  customRowCount,
  effectiveRowCount,
  showDropdown,
  showInputWarning = false,
  options,
  disabled = false,
  onToggleDropdown,
  onCloseDropdown,
  onSelect,
  onCustomChange,
}) => {
  return (
    <div className="relative w-full sm:w-auto">
      <Button
        variant="secondary"
        size="sm"
        onClick={onToggleDropdown}
        disabled={disabled}
        rightIcon={<ChevronDown className="w-3 h-3 text-neutral-400" />}
        className="whitespace-nowrap justify-center w-full sm:w-auto"
        data-tour="results-button"
      >
        {effectiveRowCount} results
      </Button>

      {showDropdown && !disabled && (
        <>
          <div className="fixed inset-0 z-10" onClick={onCloseDropdown} />
          <Card
            padding="none"
            shadow="md"
            className="absolute bottom-full left-0 mb-2 w-[130px] z-20 py-2 rounded-xl"
            data-tour="results-dropdown"
          >
            {options.map((n) => (
              <button
                key={n}
                onClick={() => onSelect(n)}
                className={`w-full px-3 py-2 text-left text-[13px] hover:bg-neutral-50 transition-colors ${
                  rowCount === n && !customRowCount ? 'text-neutral-900 font-medium bg-neutral-50' : 'text-neutral-600'
                }`}
              >
                {n} results
              </button>
            ))}
            <div className="border-t border-neutral-100 mt-2 pt-2 px-2 pb-1">
              <input
                type="text"
                value={customRowCount}
                onChange={(e) => onCustomChange(e.target.value.replace(/\D/g, ''))}
                placeholder="Custom..."
                className={`w-full px-2.5 py-1.5 text-[13px] rounded-lg border outline-none transition-colors ${
                  customRowCount
                    ? showInputWarning
                      ? 'border-red-400 bg-red-50'
                      : 'border-neutral-300 bg-neutral-50'
                    : 'border-neutral-200'
                }`}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </Card>
        </>
      )}
    </div>
  );
};
